import React from 'react';
import SecondaryActionBar from '../../../ActionBar/SecondaryActionBar';
export const SecondaryActionBarWrapper = ({ children , deviation , withSecondaryActionBar , className  })=>{
    return withSecondaryActionBar ? /*#__PURE__*/ React.createElement(SecondaryActionBar, {
        deviation: deviation,
        wrapperClassName: className
    }, children) : /*#__PURE__*/ React.createElement(React.Fragment, null, children);
};
SecondaryActionBarWrapper.displayName = 'SecondaryActionBarWrapper';
export default SecondaryActionBarWrapper;
